import React, { FC, useState } from 'react'
import MetricsForm from './MetricsForm'
import { useDatasetMetrics } from '../../../hooks/useDatasetMetrics'
import { CreateDatasetMetricsParams } from 'tabs/data/api/metrics'
import { CButton } from 'tabs/data/components/CButton'
import { alertError, alertSuccess } from 'api'
import { CrossIcon } from 'uiKit/icons/CrossIcon'
import * as S from './DatasetMetrics.style'

type NewDatasetMetricsProps = {
  datasetId: string
  tableId: string
  hasItems: boolean
  onSubmit: () => Promise<void>
}

export const NewDatasetMetrics: FC<NewDatasetMetricsProps> = ({ datasetId, tableId, hasItems, onSubmit }) => {
  const { createMetric } = useDatasetMetrics()
  const [open, setOpen] = useState(false)

  const resetForm = () => {
    setOpen(false)
  }

  const handleCreateTable = async (params: CreateDatasetMetricsParams) => {
    try {
      const response = await createMetric(datasetId, tableId, params)

      if (response) {
        alertSuccess('Metric created successfully.', 3000)
        resetForm()
        await onSubmit()
      }
    } catch (error) {
      switch (error.response.status) {
        case 404:
          throw alertError('The table that was already deleted')
        case 409:
          throw alertError('Provided Metric name already exists')
        case 412:
          throw alertError('Error! Someone already made changes. Please reload page and try again.')
        default:
          throw alertError(error?.message || error || 'Error creating column')
      }
    }
  }

  return (
    <div style={hasItems ? { paddingTop: '1rem' } : { padding: '2rem 1rem 1rem', textAlign: 'center' }}>
      {open && (
        <S.CreateForm>
          <h5 style={{ textAlign: 'center' }}>New Metric</h5>
          <S.IconWrap onClick={resetForm}>
            <CrossIcon color={'var(--color-spun-pearl-grey)'} />
          </S.IconWrap>

          <MetricsForm
            description=""
            name=""
            type={null}
            rules={[]}
            formula=""
            synonyms={[]}
            isActive={true}
            onSubmit={handleCreateTable}
            onCancel={resetForm}
          />
        </S.CreateForm>
      )}

      {!open && (
        <CButton label={hasItems ? '+ Add Metric' : 'Create Metric'} color="primary" onClick={() => setOpen(true)} />
      )}
    </div>
  )
}
